
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { LocaleItemProps } from ".";
import { loading, index, options } from "store/locale";

interface ApiLocaleInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiLocaleOutputProps = OutputBaseProps<{ list: LocaleItemProps[]; pagination?: PaginationProps; }>

export const apiLocaleIndex = async (data: ApiLocaleInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLocaleOutputProps>("/api/locales", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiLocaleOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLocaleOutputProps>("/api/locales", { params: { ...data, fields: "id,code,name,translateEditor" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};